import { combineReducers, type Reducer, type ReducersMapObject } from 'redux';

import { STORE_SECTION_NAME } from '../constants';

import { reducer as issueInfoReducer, State as IssueInfoState } from './issueinfo';
import { reducer as layoutReducer, State as LayoutState } from './layout';
import { reducer as restrictionsReducer, State as RestrictionsState } from './restrictions';

interface IssueState {
    issueInfo: IssueInfoState;
    restrictions: RestrictionsState;
    layout: LayoutState;
}

const reducers: ReducersMapObject<IssueState> = {
    issueInfo: issueInfoReducer,
    restrictions: restrictionsReducer,
    layout: layoutReducer,
};

const reducer: Reducer<IssueState> = combineReducers(reducers);

const getIssueState = (state: Record<string, unknown>) => state[STORE_SECTION_NAME] as IssueState;

export { IssueState };
export { getIssueState, reducer };
